import type { Kitchen } from '../../libs';
import { getTimeZone } from '../../libs/utils/helperFunctions';

export const timeInKitchen = (iso: string, kitchen: Kitchen): string =>
  new Intl.DateTimeFormat('en-GB', {
    timeZone: getTimeZone(kitchen),
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23'
  }).format(new Date(iso));

export const dateInKitchen = (kitchen: Kitchen, now: Date): string =>
  new Intl.DateTimeFormat('en-GB', {
    timeZone: getTimeZone(kitchen),
    weekday: 'long',
    day: 'numeric',
    month: 'long'
  }).format(now);
